import { ReactElement, useMemo } from 'react';

import { ICD10Disease } from '@dreryk/egabinet-icd-dictionary-frontend-api';
import { VisitDiagnosis } from '@dreryk/egabinet-visit-frontend-api';

import { FormContextValues } from '@dreryk/react-common';

import { StyledDiseaseField } from './DiseaseField.styled';

type DiseaseFieldFormBeanPart = {
   diagnosis: ICD10Disease | null;
};

type DiseaseFieldProps = {
   readonly register: FormContextValues<DiseaseFieldFormBeanPart>['register'];
   readonly dictionaryValidOn: Date;
   readonly visitDiagnoses: VisitDiagnosis[] | undefined;
};

export const DiseaseField = (props: DiseaseFieldProps): ReactElement => {
   const defaultItems = useMemo(
      () =>
         props.visitDiagnoses?.map((diagnosis) => ({
            code: diagnosis.icd10Code,
            name: diagnosis.name,
         })) ?? [],
      [props.visitDiagnoses]
   );

   const defaultValue = defaultItems.length === 1 ? defaultItems[0] : undefined;

   return (
      <StyledDiseaseField
         testId={'diagnosis'}
         name={'diagnosis'}
         dictionaryValidOn={props.dictionaryValidOn}
         register={props.register}
         validationRules={{ required: true }}
         defaultValue={defaultValue}
         defaultItems={defaultItems}
      />
   );
};
